define('model/disclosure.decision.model',['require','exports','module','fukit'],function(require, exports, module) {
  var BaseModel = require('fukit').BaseModel;

  var DisclosureDecisionModel = BaseModel.extend({
    radioRequests: {
      'models DisclosureDecisionModel': '@constructor',
    },

    useHalSelfLinkAsUrl: false,

    urlRootTemplate: '/api/v1/compliance/disclosure/:documentId/decision',
  });

  module.exports = DisclosureDecisionModel;
});

